// import something here
import userLocalStorage from '../utils/user-local-storage'

// leave the export, even if you don't use it
export default ({ app, router, Vue }) => {
  // something to do
  Vue.prototype.$userLocalStorage = userLocalStorage
}
